import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyA-9je9mNfMtikQx881uyptkUleTtwkxw4',
  authDomain: 'pve25-92b88.firebaseapp.com',
  databaseURL: 'https://pve25-92b88-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'pve25-92b88',
  storageBucket: 'pve25-92b88.firebasestorage.app',
  messagingSenderId: '142354266955',
  appId: '1:142354266955:web:d483a44157d1f8749c06ce',
}

firebase.initializeApp(firebaseConfig)
firebase.analytics()

const firebaseDb = firebase.database()
const firebaseAuth = firebase.auth()

const getDbRef = (dbRef) => {
  const envDbRef = `${process.env.NODE_ENV === 'production' ? 'production' : 'local'}/${dbRef}`
  return firebaseDb.ref(envDbRef)
}

const ChatDb = getDbRef('chat')
const HallOneDb = getDbRef('Hall_A_Question')
const HallTwoDb = getDbRef('Hall_B_Question')
const HallOneChatDb = getDbRef('Hall_A_Chat')
const HallTwoChatDb = getDbRef('Hall_B_Chat')
const NoticeDb = getDbRef('notice')
const NotificationDb = getDbRef('pushNotifications')
const PopupRef = getDbRef('LaunchPopup')
const VideoRef = getDbRef('GrowthCentre')
const AuditoriumClosedRef = getDbRef('auditoriumAccess')
const AuditoriumChat = getDbRef('Auditorium_Chat')
const AuditoriumQuestion = getDbRef('auditoriumQuestions')

const GalleryAccessRef = getDbRef('galleryAccess')
const NetworkingAccessRef = getDbRef('networkingAccess')
const GameAccessRef = getDbRef('gameAccess')
const ClosePathToLobbyRef = getDbRef('closePathToLobby')
const LobbyAccessRef = getDbRef('lobbyAccess')

const getUniqueSessionDb = (uid) => getDbRef(`uniqueSession/${uid}`)
const getUserCountDb = (uid, path) => getDbRef(`userCount/${path}/${uid}`)
const getUserSessionDb = (uid) => getDbRef(`userSessions/${uid}`)
const getOnlineStatusDb = (uid) => getDbRef(`onlineStatus/${uid}`)
const getLiveCheckInSessionDb = (hallNumber) => getDbRef(`liveCheckInSession/hall-${hallNumber}`)
const getRefreshDb = (uid) => getDbRef(`shouldRefresh/${uid}`)
const getLiveSessionDb = (hallNumber) => getDbRef(`liveSession/${hallNumber}`)

// Leaderboard references
const LeaderboardDb = getDbRef('leaderboard')
const getLeaderboardUserDb = (userId) => getDbRef(`leaderboard/${userId}`)

export {
  firebaseDb,
  firebaseAuth,
  ChatDb,
  HallOneDb,
  HallTwoDb,
  HallOneChatDb,
  HallTwoChatDb,
  NoticeDb,
  NotificationDb,
  PopupRef,
  VideoRef,
  AuditoriumClosedRef,
  AuditoriumChat,
  AuditoriumQuestion,
  GalleryAccessRef,
  NetworkingAccessRef,
  GameAccessRef,
  ClosePathToLobbyRef,
  LobbyAccessRef,
  getUniqueSessionDb,
  getUserCountDb,
  getUserSessionDb,
  getOnlineStatusDb,
  getLiveCheckInSessionDb,
  getRefreshDb,
  getLiveSessionDb,
  LeaderboardDb,
  getLeaderboardUserDb,
}
